const invoiceData = { invoiceData: {} };

function invoiceReducer(state = { invoiceData }, action) {
  const { data } = action.payload;
  switch (action.type) {
    case 'setInvoiceData':
      return {
        ...state,
        invoiceData: { ...state.invoiceData, ...data },
      };
    case 'updateInvoiceData':
      return {
        ...state,
        invoiceData: { ...state.invoiceData, ...data },
      };
    default:
      return state;
  }
}
export default invoiceReducer;
